enum AccountReceivableStatusEnum {
  paid = 'paid',
  due = 'due',
  expire = 'expire',
  none = 'none',
}

export default AccountReceivableStatusEnum;
